// extracted by mini-css-extract-plugin
module.exports = {"map":"SwitchableMap_map__zJIbH","staticMap":"SwitchableMap_staticMap__osIGZ","hidden":"SwitchableMap_hidden__N3eY5"};